import { mapGetters } from 'vuex';
import _ from 'lodash';

const removeDropletHook = {
  computed: {
    ...mapGetters(['currentSite', 'currentPage']),
  },
  data() {
    return {
      subLists: {
        grid: 'rows',
        accordion: 'sections',
        columns: 'columns',
        tabs: 'tabs',
        modal: 'droplets',
      },
    };
  },
  methods: {
    updateFormCount(form) {
      const formList = this.currentSite.forms;
      if (formList && this.currentPage.type !== 'draft') {
        const i = _.findIndex(formList, f => f === form._id);
        if (i >= 0) {
          this.$store.dispatch('spliceDropletVal', {
            array: formList,
            index: i,
          });
        }
      }
      const list = this.currentPage.type !== 'draft' ? 'forms' : 'draftForms';
      const pageForms = this.currentPage[list];
      if (pageForms) {
        const i = _.findIndex(pageForms, f => f === form._id);
        if (i >= 0) {
          this.$store.dispatch('spliceDropletVal', {
            array: pageForms,
            index: i,
          });
        }
      }
    },
    async removeDropletHook(droplet) {
      const type = this._dropletType(droplet);
      if (type.name === 'form') {
        this.updateFormCount(droplet);
      }
      // deep search for nested droplets
      if (type.puddle || type.section) {
        const subList = type.puddle ? droplet[this.subLists[type.name]] : droplet.droplets;
        await this._deepFind(
          {
            entry: subList,
            key: '_id',
          }, (nestedDroplet) => {
            const isDroplet = this._dropletType(nestedDroplet);
            if (isDroplet.any) {
              // run action again
              if (isDroplet.name === 'form') {
                this.updateFormCount(nestedDroplet);
              }
            }
          },
        );
      }
    },
  },
};

export { removeDropletHook };



// WEBPACK FOOTER //
// ./src/mixins/remove-droplet.js